require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-guessing-stegersbach.json") })
        }
      }, "path---betreuungseinrichtungen-guessing-stegersbach");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-guessing-stegersbach!./.cache/json/betreuungseinrichtungen-guessing-stegersbach.json
// module id = 903
// module chunks = 231608221292675